import { Progress } from "@mantine/core";

import classNames from "./Progress.module.css";

export const progressComponentSettings = Progress.extend({
  classNames,
});
